var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubyBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ruby-black",
    xmlns: "http://www.w3.org/2000/svg",
    width: 437.938,
    height: 437.939,
    viewBox: "0 0 437.938 437.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M4.293,110.143,114.2.236l48.848,109.908Z",
    transform: "translate(121.042 6.64)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M162.2,0,56.173,106.032,9.047,0Z",
    transform: "translate(255.09)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M.236,114.2l109.912,48.849V4.293Z",
    transform: "translate(6.637 121.042)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M106.029,56.172,0,9.047V162.2Z",
    transform: "translate(0 255.094)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M5,130.335,130.335,5H5Z",
    transform: "translate(140.98 140.98)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M125.164,380.952,11.093,114.78,125.164.707Z",
    transform: "translate(312.774 19.938)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M258.568,258.567,150.058,5.376,5.376,150.058Z",
    transform: "translate(151.573 151.577)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M114.777,11.093,380.94,125.161H.707Z",
    transform: "translate(19.938 312.777)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyBlack);
export default __webpack_public_path__ + "static/media/ruby-black.cf94948ab7c216d383f394eb7f97e425.svg";
export { ForwardRef as ReactComponent };